import {
  BASIC_AUTH,
  FORM_ENDPOINT_URL,
  IS_STAGING,
  language,
  UNBOUNCE_STAGING_RECAPTCHA_SITE_KEY,
  UNBOUNCE_PRODUCTION_RECAPTCHA_SITE_KEY,
} from '../shared/config';

const formatLanguage = (lang: string) => (lang ? lang.charAt(0).toUpperCase() + lang.slice(1).toLowerCase() : '');

export const handleUnbounceFormSubmission = (form: HTMLFormElement) => {
  const $form = $(form);

  // Remove old handlers on this form only
  $form.off('submit');

  // Remove action
  $form.attr('action', '');

  $form.on('submit', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    const $submitBtn = $form.find('[type="submit"]');
    $submitBtn.val('Submitting...').prop('disabled', true);

    const $errorMessage = $form.closest('.form-wrapper').find('.error-message');
    $errorMessage.css('display', 'none');

    const UNBOUNCE_RECAPTCHA_SITE_KEY = IS_STAGING
      ? UNBOUNCE_STAGING_RECAPTCHA_SITE_KEY
      : UNBOUNCE_PRODUCTION_RECAPTCHA_SITE_KEY;

    grecaptcha.enterprise
      .execute(UNBOUNCE_RECAPTCHA_SITE_KEY, { action: 'form_submit' })
      .then((token) => {
        let formData = $form.serializeArray();

        const firstName = formData.find((f) => f.name === 'first_name')?.value || '';
        const lastName = formData.find((f) => f.name === 'last_name')?.value || '';
        const name = `${firstName} ${lastName}`.trim();

        const caseTypeMap: Record<string, number> = {
          'Animal Bite': 1,
          Assault: 2,
          Employment: 25,
          'Medical Malpractice': 18,
          'Motor Vehicle Accident': 20,
          'Product Liability': 27,
          'Sexual Assault': 2,
          'Slip and Fall': 26,
          'Social Security & Disability': 32,
          'Workplace Injury': 37,
          'Other Injury': 34,
          'Something Else': 19,
        };

        const caseTypeField = formData.find((f) => f.name === 'case_type');
        if (caseTypeField) {
          formData = formData.filter((f) => f.name !== 'case_type');
          formData.push({ name: 'case_kind_id', value: caseTypeMap[caseTypeField.value].toString() || '' });
        }

        const tellUsField = formData.find((f) => f.name === 'tell_us_what_happened');
        if (tellUsField) {
          formData = formData.filter((f) => f.name !== 'tell_us_what_happened');
          formData.push({ name: 'body', value: tellUsField.value });
        }

        formData = formData.filter(
          (f) => f.name !== 'first_name' && f.name !== 'last_name' && f.name !== 'pageId' && f.name !== 'pageVariant',
        );
        formData.push({ name: 'name', value: name });
        formData.push({ name: 'visit_token', value: localStorage.getItem('visitToken') || '' });
        formData.push({ name: 'campaign_id', value: localStorage.getItem('campaignId') || '' });
        formData.push({ name: 'form_url', value: window.location.href });
        formData.push({ name: 'g-recaptcha-response', value: token });
        formData.push({ name: 'website', value: 'unbounce' });

        const payload: Record<string, string> = {};
        formData.forEach((f) => {
          payload[f.name] = f.value;
        });

        payload.website = 'unbounce';

        payload.language = formatLanguage(payload.language || language);

        const headers = IS_STAGING ? { Authorization: BASIC_AUTH } : {};

        $.ajax({
          url: FORM_ENDPOINT_URL,
          method: 'POST',
          data: payload,
          headers,
        })
          .done((data) => {
            console.log('Form submission successful:', data);
            $submitBtn.val('Submit').prop('disabled', false);

            // HIDE the form
            $form.hide();

            // SHOW the success message
            const $successMessage = $form.closest('.form-wrapper').find('.success-message');
            $successMessage.css('display', 'block'); // or .show()

            const $recaptchaMessage = $form.closest('.form-wrapper').find('.recaptcha-message');
            $recaptchaMessage.css('display', 'none'); // or .hide()
          })
          .fail((xhr, status, error) => {
            console.error('Error:', xhr.responseText, status, error);
            $submitBtn.val('Submit').prop('disabled', false);
            const $errorMessage = $form.closest('.form-wrapper').find('.error-message');
            $errorMessage.show();
          });
      })
      .catch((error) => {
        $submitBtn.val('Submit').prop('disabled', false);
        console.error('ReCAPTCHA Error:', error);
        alert('ReCAPTCHA verification failed. Please try again.');
        const $errorMessage = $form.closest('.form-wrapper').find('.error-message');
        $errorMessage.show();
      });

    return false;
  });
};
